import { Appearance } from '@stripe/stripe-js'

/**
 * QuickPass theming for the embedded Stripe Payment Element, shared by the rent
 * pay page and the autopay setup page so the payment form reads as part of the
 * app rather than a foreign iframe. Values mirror the quickpass colour tokens
 * in panda.config.ts.
 */
const PAYMENT_ELEMENT_APPEARANCE: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#8054FF',
    colorText: '#1A1330',
    colorTextSecondary: '#5A4F78',
    colorBackground: '#FFFFFF',
    colorDanger: '#9B3B3B',
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    borderRadius: '10px',
  },
}

export { PAYMENT_ELEMENT_APPEARANCE }
